import { render, staticRenderFns } from "./MservicetechnicianCreate.vue?vue&type=template&id=c2491ff8&scoped=true"
import script from "./MservicetechnicianCreate.vue?vue&type=script&lang=js"
export * from "./MservicetechnicianCreate.vue?vue&type=script&lang=js"
import style0 from "./MservicetechnicianCreate.vue?vue&type=style&index=0&id=c2491ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2491ff8",
  null
  
)

export default component.exports